import { ServerApi } from '@/config/apis/server-api';
import { SERVER_ROUTES } from '@/config/routes/server-routes';
import { ServerApiErrorManager } from '@/shared/application/error/managers/server-api-error.manager';
import { ServerApiResponseManager } from '@/shared/application/response/managers/server-api-response.manager';
import { ServerResponse } from '@/shared/types/server/response/server-response';

export const submitService = async <
  Data = { [key: string]: unknown },
  Payload = { [key: string]: any },
>(
  route: keyof typeof SERVER_ROUTES,
  data: Data,
  onSuccess: (serverResponse: ServerResponse<Payload>) => void,
  opts?: {
    replace?: [string, string][];
  },
) => {
  try {
    const serverApi = ServerApi.createByUrl(location.href);

    const serverResponse = await serverApi.request<Payload>(route, data, opts);

    // Exibe alertas automaticamente caso exista mensagens.
    ServerApiResponseManager.handleSuccessSubmit(serverResponse);

    onSuccess(serverResponse);
  } catch (error) {
    ServerApiErrorManager.handleMessage(error);
  }
};
